import { Fragment, useState, useEffect } from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import Loader from '../../../../common/Loader';
import { callServices } from '../../../../common/timeLiveFunction';
import { useAuth } from '../core/Auth';
import { getUserAuthentication } from '../core/_requests';

const initialValues = {
  verificationCode: "",
  emailAddress: ""
}

const objErrorValues = {
  isShow: false,
  isError: false,
  message: "",
}

var base_url = window.origin + '/classic/';
const { REACT_APP_TIMELIVE_API_URL, NODE_ENV } = process.env;

export function MultiFactorVerification() {
  const [verificationValues, setVerificationValues] = useState<any | ''>(initialValues);
  const [isMFAAuthenticationList, setIsMFAAuthenticationList] = useState(true);
  const [SystemMultiFactorAuthenticationTypeId, setSystemMultiFactorAuthenticationTypeId] = useState(1);
  const [errorValues, setErrorValues] = useState<any | ''>(objErrorValues);
  const [isLoading, setIsLoading] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (NODE_ENV === "development") {
      base_url = REACT_APP_TIMELIVE_API_URL as string;
    }
    updateVerificationCode();
  }, [SystemMultiFactorAuthenticationTypeId]);

  const updateVerificationCode = async () => {
    setIsLoading(true);
    try {
      const response: any = await fetch(`${base_url}api/Account/UpdateMFADetail/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          "AccountId": location.state.AccountId,
          "AccountEmployeeId": location.state.AccountEmployeeId,
          "Username": location.state.Username,
          "SystemMultiFactorAuthenticationTypeId": SystemMultiFactorAuthenticationTypeId
        })
      });
      const json = await response.json();
      if (json.StatusCode === "200") {
        setVerificationValues({
          ...verificationValues,
          emailAddress: json.message
        });
      }
    } catch {

    } finally {
      setIsLoading(false);
    }
  }

  const login = async (value: any) => {
    setIsLoading(true);
    setErrorValues({
      ...errorValues,
      isShow: false,
      isError: false,
      message: ""
    });
    try {
      const response: any = await fetch(`${base_url}api/Account/TimeLiveLoginWithCode/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          "AccountId": location.state.AccountId,
          "AccountEmployeeId": location.state.AccountEmployeeId,
          "Code": value.verificationCode,
          "SystemMultiFactorAuthenticationTypeId": SystemMultiFactorAuthenticationTypeId
        })
      });
      const json = await response.json();
      if (!json.hasOwnProperty('message')) {
        if (json[0].SwitchAccountId > 0) {
          if (await callServices(json[0].AccessToken)) {
            setIsLoading(false);
          }
        } else {
          localStorage.setItem('accessToken', json[0].AccessToken);
          localStorage.setItem('accountEmployeeId', json[0].AccountEmployeeId);
          localStorage.setItem('isXeroConnected', json[0].IsXeroConnected.toString());
          localStorage.setItem('userEmailAddress', json[0].EMailAddress);
          localStorage.setItem('userRole', json[0].Role);
          localStorage.setItem('accountId', json[0].AccountId);
          localStorage.setItem('systemCategoryPageFrontEnd', json[0].SystemCategoryPageFrontEnd);
          localStorage.setItem('DefaultAccountPageId', json[0].DefaultAccountPageId);

          let object = {
            "id": 0,
            "first_name": "",
            "last_name": "",
            "email": "",
            "created_at": "2023-07-12T13:39:05.000000Z",
            "email_verified_at": "2023-07-12T13:39:05.000000Z",
            "updated_at": "2023-07-12T13:39:05.000000Z",
            "api_token": "",
            "AccountId": 0,
            "AccountEmployeeId": 0,
            "AccountRoleId": 0,
            "ProfilePictureColor": "",
            "EmployeeInitials": "",
            "EmployeeNameWithCode": "",
            "HoursPerDay": "",
            "UserInterfaceLanguage": ""
          }
          json.map((item: any) => {
            object.id = item.AccountEmployeeId;
            object.first_name = item.FirstName;
            object.last_name = item.LastName;
            object.email = item.EMailAddress;
            object.api_token = item.AccessToken;
            object.AccountId = item.AccountId;
            object.AccountEmployeeId = item.AccountEmployeeId;
            object.AccountRoleId = item.AccountRoleId;
            object.ProfilePictureColor = item.ProfilePictureColor;
            object.EmployeeInitials = `${item.FirstName.toUpperCase().split('')[0]}${item.LastName.toUpperCase().split('')[0]}`;
            object.EmployeeNameWithCode = item.EmployeeNameWithCode;
            object.HoursPerDay = item.HoursPerDay;
            object.UserInterfaceLanguage = item.UserInterfaceLanguage;
          })
          saveAuth(object);
          let data = await getUserAuthentication(json[0].AccessToken, json[0].AccountEmployeeId);
          setCurrentUser(data);
          setErrorValues({
            ...errorValues,
            isShow: false,
            message: ""
          });
        }
      }
      else {
        setErrorValues({
          ...errorValues,
          isShow: true,
          message: json.message
        });
      }
    } catch {

    } finally {
      setIsLoading(false);
    }
  }
  const handleClickto = (AccountId: any, AccountEmployeeId: any, Username: any, SystemMultiFactorAuthenticationTypeId: any) => {
    if (!AccountId) {
      console.error("AccountId is missing");
      return;
    }
    
    //setIsAuthenticatorApplicationAuthentication(true); setIsAddAuthentication(false); setIsEmailAuthentication(false);
    // Set states or navigate to the next page as required
    setIsMFAAuthenticationList(false);
    setSystemMultiFactorAuthenticationTypeId(SystemMultiFactorAuthenticationTypeId) 
    //setIsAddAuthentication(false);
    //setIsAuthenticatorApplicationAuthentication(true);
  
    // Redirect to the next page
/*   navigate('/auth/MultiFactorVerification', {
    state: {
      AccountId: AccountId,
      AccountEmployeeId: AccountEmployeeId,
      Username: Username,
      SystemMultiFactorAuthenticationTypeId: SystemMultiFactorAuthenticationTypeId, // Adjust the fallback value as needed
    },
  }); */

  };

  const handleClick = (AccountId: any, AccountEmployeeId: any, Username: any, SystemMultiFactorAuthenticationTypeId: any) => {
    if (!AccountId) {
      console.error("AccountId is missing");
      return;
    }
    setIsMFAAuthenticationList(false);
    setSystemMultiFactorAuthenticationTypeId(SystemMultiFactorAuthenticationTypeId) 
    // Set states or navigate to the next page as required
    //setIsEmailAuthentication(true);
    //setIsAddAuthentication(false);
    //setIsAuthenticatorApplicationAuthentication(false);
  
    // Redirect to the next page
/*   navigate('/auth/MultiFactorVerification', {
    state: {
      AccountId: AccountId,
      AccountEmployeeId: AccountEmployeeId,
      Username: Username,
      SystemMultiFactorAuthenticationTypeId: SystemMultiFactorAuthenticationTypeId
    },
  }); */

  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="d-flex flex-column flex-root" style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/container-bg.svg')})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100vh',
        width: '100%',
        position: 'relative'
        //backgroundColor: '#f2f6f8'
      }}>
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div className="d-flex flex-lg-row-fluid">
            <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
              <img className="theme-light-show mx-auto mw-100 w-150px w-lg-500px mb-10" src={toAbsoluteUrl('/media/backgrounds/LoginBackground.svg')} alt="" />
              <h1 className="fs-2qx fw-bold text-center mb-7 textDarkBlue">
                Fast, Efficient and Productive
              </h1>
              <div className="color-TextDarkBlue fs-base text-center fw-semibold">
                Discover the ultimate time tracking software designed to streamline your business operations.
                <br /> Our intuitive platform simplifies time and expense,<br /> ensuring accuracy and efficiency in managing your projects and its expenses.
              </div>
            </div>
          </div>
          <Formik
            initialValues={verificationValues}
            enableReinitialize={true}
            onSubmit={values => { login(values) }}
            validationSchema={yup.object().shape({
              verificationCode: yup
                .string()
                .label('Verification Code')
                .required()
            })}
          >
            {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm }) => (
              <Fragment>
                <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                  <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-525px p-10 loginShadow">
                    <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-425px" >
                      <div className="d-flex flex-column flex-column-fluid pb-15 pb-lg-20 mt-4">
                        <div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
                          {isMFAAuthenticationList &&
                          <>
<div className="text-center mb-10">
                            <img
                              alt='Logo'
                              src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                              className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                            />
                            <h3 className="card-title fw-bold signTitle">
                              Multi-Factor Verification
                            </h3>
                            <div className="text-gray-500 fs-6">
                              {/* {`An email with a 6-digit verification code was sent to ${verificationValues.emailAddress}`} */}
                              {`For added security, we need to further verify your account.`}
                            </div>
                                            <div className="mb-3">
                                                <div className="row mb-3 " >
                                                    <span className="card-title fw-bold headerTitle text-center">
                                                         Verified By

                                                         </span>
                                                </div>

                                                <div className='separator mb-3'></div>


                                                <div className="row mb-3"
                                                        onClick={() => handleClick(location.state.AccountId, location.state.AccountEmployeeId, location.state.Username,2)}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <div className="col-md-12">
                                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed flex-shrink-0 p-2 align-items-center">
                                                            <i className="ki-outline bi bi-envelope fs-3 text-primary me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                            </i>
                                                            <div className="d-flex flex-column flex-grow-1">
                                                                <div className="mb-3 mb-md-0 fw-semibold">
                                                                    <h4 className="text-gray-700 fw-bold fs-3">
                                                                        Email
                                                                        </h4>
                                                                    <div className="fs-7 text-gray-600 pe-7">
                                                                        Verification codes sent by email.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row"
/*                                                     onClick={() => { 
                                                        setIsAuthenticatorApplicationAuthentication(true); setIsAddAuthentication(false); setIsEmailAuthentication(false); 
                                                        navigate('/auth/MultiFactorVerification');                                                    
                                                    }} */
                                                        onClick={() => handleClickto(location.state.AccountId, location.state.AccountEmployeeId, location.state.Username,1)}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <div className="col-md-12">
                                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed flex-shrink-0 p-2 align-items-center">
                                                            <i className="ki-outline bi bi-shield-shaded fs-3 text-primary me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                            </i>
                                                            <div className="d-flex flex-column flex-grow-1">
                                                                <div className="mb-3 mb-md-0 fw-semibold">
                                                                    <h4 className="text-gray-700 fw-bold fs-3" >
                                                                        Authenticator Application (TOTP)
                                                                        </h4>
                                                                    <div className="fs-7 text-gray-600 pe-7">
                                                                        Use a TOTP Authenticator app to get verification codes.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                            
                          </div>
                          
                          </>

                          }
                          {isMFAAuthenticationList === false &&
<>
<div className="text-center mb-10">
                            <img
                              alt='Logo'
                              src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                              className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                            />
                            <h3 className="card-title fw-bold signTitle">
                              Please verify your account
                            </h3>
                            {SystemMultiFactorAuthenticationTypeId === 2 && (
                            <div className="text-gray-500 fs-6">
                              {`An email with a 6-digit verification code was sent to ${verificationValues.emailAddress}`}
                            </div>
                            )}
                            {SystemMultiFactorAuthenticationTypeId === 1 && (
                            <div className="text-gray-500 fs-6">
                              {`Enter 6-Digit code from your Authenticator App `}
                              {`${verificationValues.emailAddress}`}
                            </div>
                            )}
                          </div>
                          {errorValues.isShow &&
                            <div id="validationerror" className={errorValues.isError ? "alert alert-danger" : "alert alert-success"}>
                              <strong>{errorValues.isError ? "Error!" : "Success"}</strong>
                              <ul>
                                <li>{errorValues.message}</li>
                              </ul>
                            </div>
                          }
                          <div className="fv-row mb-8 fv-plugins-icon-container">
                            <input
                              type="text"
                              placeholder="Verification Code"
                              name="verificationCode"
                              value={values.verificationCode}
                              onChange={handleChange('verificationCode')}
                              className='form-control fs-6 fw-normal'
                            />
                            <div>
                              {touched.verificationCode && errors.verificationCode &&
                                <p className='errorMsg'>{errors.verificationCode as string}</p>
                              }
                            </div>
                          </div>
                          <div className="d-grid mb-4">
                            <button
                              type="button"
                              className="btn btn-primary btn-bs-btn-font-weight me-2 fs-6"
                              onClick={() => handleSubmit()}
                              disabled={!isValid}
                            >
                              {('Login')}
                            </button>
                          </div>
</>
                          }

                        </div>
                      </div>
                      <div className=" d-flex flex-stack">
                        <div className="text-gray-500 text-center fs-6 mt-8">
                          By clicking Sign In button, I agree to Livetecs
                          <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Terms Of Use')}
                          </a> and <a href="https://www.livetecs.com/privacy-policy/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Privacy Policy')}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </Formik>
        </div>
      </div>
    </>
  )
}